import React from 'react';
import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';
import { ScrollableTextBlocksWithBackgroundImagesType } from '../../../../../../../types/ScrollableTextBlocksWithBackgroundImagesType';
import { ScrollableTextBlocksWithBackgroundImages } from '../../../../SectionBlocks/blocks/Parallax/ScrollableTextBlocksWithBackgroundImages';
import { BlockContentContext } from '../../../BlockContent.utils';

interface ParallaxProps {
  value: ScrollableTextBlocksWithBackgroundImagesType;
}

export const ParallaxBlock = ({ value }: ParallaxProps) => <ScrollableTextBlocksWithBackgroundImages block={value} />;

export const ParallaxSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: ParallaxProps) => (
      <ArticleParallaxContentGridCol className="parallax">
        <ParallaxBlock value={value} />
      </ArticleParallaxContentGridCol>
    );
  }
  return ({ value }: ParallaxProps) => <ParallaxBlock value={value} />;
};

const ArticleParallaxContentGridCol = styled.div`
  grid-column: 1 / -1;
  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
`;
